/* tslint:disable */
/* eslint-disable */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { IContractor } from '../models';
// @ts-ignore
import type { IContractorDetail } from '../models';
/**
 * ContractorApi - axios parameter creator
 */
export const ContractorApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Check if a contractor can be deleted
         * @param {string} shortName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        canDeleteContractor: async (shortName: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'shortName' is not null or undefined
            assertParamExists('canDeleteContractor', 'shortName', shortName)
            const localVarPath = `/api/contractor/canDelete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (shortName !== undefined) {
                localVarQueryParameter['shortName'] = shortName;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new contractor
         * @param {IContractorDetail} iContractorDetail 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createContractor: async (iContractorDetail: IContractorDetail, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'iContractorDetail' is not null or undefined
            assertParamExists('createContractor', 'iContractorDetail', iContractorDetail)
            const localVarPath = `/api/contractor/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(iContractorDetail, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a contractor if not used in the system
         * @param {string} shortName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteContractor: async (shortName: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'shortName' is not null or undefined
            assertParamExists('deleteContractor', 'shortName', shortName)
            const localVarPath = `/api/contractor/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (shortName !== undefined) {
                localVarQueryParameter['shortName'] = shortName;
            }


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all contractors with canDelete flag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllContractors: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/contractor/getAllContractors`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get contractor by shortName
         * @param {string} shortName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContractorById: async (shortName: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'shortName' is not null or undefined
            assertParamExists('getContractorById', 'shortName', shortName)
            const localVarPath = `/api/contractor/getById`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (shortName !== undefined) {
                localVarQueryParameter['shortName'] = shortName;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update an existing contractor
         * @param {string} shortName 
         * @param {IContractorDetail} iContractorDetail 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateContractor: async (shortName: string, iContractorDetail: IContractorDetail, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'shortName' is not null or undefined
            assertParamExists('updateContractor', 'shortName', shortName)
            // verify required parameter 'iContractorDetail' is not null or undefined
            assertParamExists('updateContractor', 'iContractorDetail', iContractorDetail)
            const localVarPath = `/api/contractor/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (shortName !== undefined) {
                localVarQueryParameter['shortName'] = shortName;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(iContractorDetail, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ContractorApi - functional programming interface
 */
export const ContractorApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ContractorApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Check if a contractor can be deleted
         * @param {string} shortName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async canDeleteContractor(shortName: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: boolean; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.canDeleteContractor(shortName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContractorApi.canDeleteContractor']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a new contractor
         * @param {IContractorDetail} iContractorDetail 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createContractor(iContractorDetail: IContractorDetail, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IContractorDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createContractor(iContractorDetail, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContractorApi.createContractor']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a contractor if not used in the system
         * @param {string} shortName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteContractor(shortName: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteContractor(shortName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContractorApi.deleteContractor']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all contractors with canDelete flag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllContractors(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<IContractor>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllContractors(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContractorApi.getAllContractors']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get contractor by shortName
         * @param {string} shortName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getContractorById(shortName: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IContractorDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getContractorById(shortName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContractorApi.getContractorById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update an existing contractor
         * @param {string} shortName 
         * @param {IContractorDetail} iContractorDetail 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateContractor(shortName: string, iContractorDetail: IContractorDetail, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IContractorDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateContractor(shortName, iContractorDetail, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContractorApi.updateContractor']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ContractorApi - factory interface
 */
export const ContractorApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ContractorApiFp(configuration)
    return {
        /**
         * 
         * @summary Check if a contractor can be deleted
         * @param {string} shortName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        canDeleteContractor(shortName: string, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: boolean; }> {
            return localVarFp.canDeleteContractor(shortName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new contractor
         * @param {IContractorDetail} iContractorDetail 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createContractor(iContractorDetail: IContractorDetail, options?: RawAxiosRequestConfig): AxiosPromise<IContractorDetail> {
            return localVarFp.createContractor(iContractorDetail, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a contractor if not used in the system
         * @param {string} shortName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteContractor(shortName: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteContractor(shortName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all contractors with canDelete flag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllContractors(options?: RawAxiosRequestConfig): AxiosPromise<Array<IContractor>> {
            return localVarFp.getAllContractors(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get contractor by shortName
         * @param {string} shortName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContractorById(shortName: string, options?: RawAxiosRequestConfig): AxiosPromise<IContractorDetail> {
            return localVarFp.getContractorById(shortName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update an existing contractor
         * @param {string} shortName 
         * @param {IContractorDetail} iContractorDetail 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateContractor(shortName: string, iContractorDetail: IContractorDetail, options?: RawAxiosRequestConfig): AxiosPromise<IContractorDetail> {
            return localVarFp.updateContractor(shortName, iContractorDetail, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ContractorApi - interface
 */
export interface ContractorApiInterface {
    /**
     * 
     * @summary Check if a contractor can be deleted
     * @param {string} shortName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    canDeleteContractor(shortName: string, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: boolean; }>;

    /**
     * 
     * @summary Create a new contractor
     * @param {IContractorDetail} iContractorDetail 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createContractor(iContractorDetail: IContractorDetail, options?: RawAxiosRequestConfig): AxiosPromise<IContractorDetail>;

    /**
     * 
     * @summary Delete a contractor if not used in the system
     * @param {string} shortName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteContractor(shortName: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Get all contractors with canDelete flag
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAllContractors(options?: RawAxiosRequestConfig): AxiosPromise<Array<IContractor>>;

    /**
     * 
     * @summary Get contractor by shortName
     * @param {string} shortName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getContractorById(shortName: string, options?: RawAxiosRequestConfig): AxiosPromise<IContractorDetail>;

    /**
     * 
     * @summary Update an existing contractor
     * @param {string} shortName 
     * @param {IContractorDetail} iContractorDetail 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateContractor(shortName: string, iContractorDetail: IContractorDetail, options?: RawAxiosRequestConfig): AxiosPromise<IContractorDetail>;

}

/**
 * ContractorApi - object-oriented interface
 */
export class ContractorApi extends BaseAPI implements ContractorApiInterface {
    /**
     * 
     * @summary Check if a contractor can be deleted
     * @param {string} shortName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public canDeleteContractor(shortName: string, options?: RawAxiosRequestConfig) {
        return ContractorApiFp(this.configuration).canDeleteContractor(shortName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new contractor
     * @param {IContractorDetail} iContractorDetail 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createContractor(iContractorDetail: IContractorDetail, options?: RawAxiosRequestConfig) {
        return ContractorApiFp(this.configuration).createContractor(iContractorDetail, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a contractor if not used in the system
     * @param {string} shortName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteContractor(shortName: string, options?: RawAxiosRequestConfig) {
        return ContractorApiFp(this.configuration).deleteContractor(shortName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all contractors with canDelete flag
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAllContractors(options?: RawAxiosRequestConfig) {
        return ContractorApiFp(this.configuration).getAllContractors(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get contractor by shortName
     * @param {string} shortName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getContractorById(shortName: string, options?: RawAxiosRequestConfig) {
        return ContractorApiFp(this.configuration).getContractorById(shortName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update an existing contractor
     * @param {string} shortName 
     * @param {IContractorDetail} iContractorDetail 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateContractor(shortName: string, iContractorDetail: IContractorDetail, options?: RawAxiosRequestConfig) {
        return ContractorApiFp(this.configuration).updateContractor(shortName, iContractorDetail, options).then((request) => request(this.axios, this.basePath));
    }
}

